import {createAction, props} from "@ngrx/store";
import {ActionsType} from "@/main/auto-gpt/store/actions.type";

export const currentChatAction = createAction (
  ActionsType.CHAT_GPT_CHECKED,
  props<{id: number}>()
)
